/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { Redirect } from 'react-router-dom';
import { translate } from 'react-i18next';
import CentralForm from 'components/CentralForm/CentralForm';
import Loading from 'components/Loading/Loading';

@translate()
@inject('authenticationStore', 'userStore')
@observer
export default class UnauthorisedAccess extends React.Component<*> {
  render() {
    const { t } = this.props;
    const { userLoaded, activeUser } = this.props.userStore;

    if (this.props.authenticationStore.authenticationState !== 'unauthed') {
      if (!userLoaded) {
        return <Loading />;
      }

      return (
        <CentralForm>
          <div>
            <h1>{t('general:unauthorised_access')}</h1>
            <p>{t('general:messages.no_access')}</p>
            <h3>{t('general:roles.labels.current_role')}</h3>
            <p>{activeUser.role_name}</p>
          </div>
        </CentralForm>
      );
    }

    return <Redirect to="/login" />;
  }
}
